import React from 'react';
import styled from 'styled-components';
import { webGL, perlin, run } from './properties';

const WaveWrapper = styled.div`
  position: absolute;
	top: 50vh;
	margin-top: -46vh;
  left: 0;
  width: 100%;
  height: 100vh;

  canvas {
	  width: 100%;
	  height: 100%;
  }

  @media only screen and (min-width: 768px) {
	  margin-top: -40vh;
  }
`;

class Wave extends React.Component {
	componentDidMount() {
    const canvas = webGL.init({
      alpha: true,
      stencil: false,
      antialias: false,
      depth: false,
    });
    canvas.blend(canvas.gl.ONE, canvas.gl.ONE);
    perlin.init();
    canvas.createBufferLine(100);
    
    run(canvas);
	}

  render() {
    return (
      <WaveWrapper>
        <canvas />
      </WaveWrapper>
    );
  }
}

export default Wave;